import styled from 'styled-components';

export const BASE_FONT = styled.div`
    font-family: 'Azo Sans', 'Roboto', arial, sans-serif;
`;
